import SendIcon from '@mui/icons-material/Send';
import { Button, ButtonProps } from '@mui/material';
import { useState } from 'react';

import { Piece } from '@apiContract';

import { Actions } from '@src/config/actions';

import { mailpieceActions } from '../index';
import { ValidationData } from '../types';
import { ActionValidation } from './ActionValidation';

interface MailpieceActionButtonProps extends ButtonProps {
  mailpiece: Piece;
  mailpieceAction: Actions;
  actionSucessCB?: () => void;
}

export const MailpieceActionButton = ({
  mailpiece,
  mailpieceAction,
  actionSucessCB,
  ...props
}: MailpieceActionButtonProps) => {
  const [validationDialogOpen, setValidationDialogOpen] = useState<boolean>(false);
  const [actionStarted, setActionStarted] = useState<boolean>(false);
  const [validationData, setValidationData] = useState<ValidationData>({});

  const actionConfig = mailpieceActions[mailpieceAction];

  const startAction = async () => {
    setActionStarted(true);
  };

  const onValidationSuccess = (data: ValidationData) => {
    setValidationData(data);
    startAction();
  };

  const onActionFinish = () => {
    setActionStarted(false);
    if (actionSucessCB) {
      actionSucessCB();
    }
  };

  if (!actionConfig) return null;

  const { title, actionTriggerColor, Component, validationSettingName } = actionConfig;

  if (!Component) return null;

  const validationSetting =
    typeof validationSettingName === 'function' ? validationSettingName(mailpiece) : validationSettingName;

  return (
    <ActionValidation
      dialogControlComponent={
        <Button variant="contained" size="large" onClick={() => setValidationDialogOpen(true)} fullWidth>
          Validate Item
        </Button>
      }
      validationDialogOpen={validationDialogOpen}
      closeValidationDialog={() => setValidationDialogOpen(false)}
      onValidationSuccess={onValidationSuccess}
      settingName={validationSetting}
      pieceType={mailpiece.pieceType}
      piecesForValidate={[mailpiece]}
    >
      <Button
        variant="contained"
        color={actionTriggerColor || 'primary'}
        size="large"
        fullWidth
        {...props}
        onClick={startAction}
        disabled={actionStarted}
        startIcon={mailpieceAction === Actions.Submit ? <SendIcon /> : null}
      >
        {typeof title === 'function' ? title(mailpiece) : title}
      </Button>

      <Component
        mailpieces={[mailpiece]}
        actionStarted={actionStarted}
        onActionFinish={onActionFinish}
        validationData={validationData}
      />
    </ActionValidation>
  );
};
